import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useRole } from '../hooks/useRole';

/**
 * Restringe una ruta a administradores. Se usa para secciones que no son de
 * gestión diaria (auditoría), donde `ProtectedOperatorRoute` no basta: aquel
 * solo aparta a los clientes, así que un rol `user` llegaba escribiendo la URL.
 *
 * La API ya rechaza a quien no es admin (`requireMinRole(ROLES.ADMIN)`), de modo
 * que nunca hubo fuga de datos; esto evita la pantalla rota —cargaba y fallaba
 * con 403— y mantiene la interfaz coherente con el menú, que ya escondía el
 * enlace.
 *
 * Superadmin pasa también, igual que en el backend, donde `requireMinRole`
 * compara por nivel y superadmin está por encima de admin.
 */
const ProtectedAdminRoute = () => {
  const { isAdmin, isSuperAdmin } = useRole();
  const { tenantCode } = useParams<{ tenantCode: string }>();

  if (!isAdmin && !isSuperAdmin) {
    return <Navigate to={`/${tenantCode}/dashboard`} replace />;
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;
